import React, {useState} from "react";
import {FormDataType, FormInitValuesType, FormParams} from "./types";

const prepareData = (initValues: FormInitValuesType) => Object.keys(initValues).reduce((acc, key) => ({...acc, [key]: initValues[key].value || ''}), {})
const prepareValid = (initValues: FormInitValuesType) => Object.keys(initValues).reduce((acc, key) => ({...acc, [key]: true}), {})

export const Form = ({children, initValues, apply}: FormParams) => {
    const [data, setData] = useState<FormDataType>(prepareData(initValues));
    const [isValid, setValid] = useState<{[key: string]: boolean}>(prepareValid(initValues))

    const setValue = (name, value) => {
        setData({...data, [name]: value})

        const checkValid = initValues[name].validationCheck
        if (checkValid) {
            const valid = checkValid(value, data);
            setValid({...isValid, [name]: valid})
        }
    }

    const onSubmit = () => {
        const notValid = Object.keys(initValues).filter(key => {
            const checkValid = initValues[key].validationCheck;
            if (checkValid) {
                return !checkValid(data[key], data);
            }
            return false;
        });

        if (notValid.length === 0) {
            apply(data);
        } else {
            setValid({...isValid, ...notValid.reduce((acc, key) => ({...acc, [key]: false}), {})})
        }
    }

    return (
        <div>
            {
                children({data, setValue, isValid, onSubmit})
            }
        </div>
    )
}